import React from 'react';
import SEO from '../components/SEO';
import BarHero from '../components/BarHero';
import BarOverview from '../components/BarOverview';
import BarGallery from '../components/BarGallery';
import OtherServices from '../components/OtherServices';

const BarRestaurant = ({ language }) => {
  return (
    <>
      <SEO
        title="Bar & Lounge"
        description="Relax and unwind at Blue Nest Hotel's Bar. Enjoy premium drinks and a welcoming atmosphere."
        url="/bar"
      />
      <BarHero language={language} />
      <BarOverview language={language} />
      <BarGallery language={language} />
      <OtherServices language={language} />
    </>
  );
};

export default BarRestaurant;
